import { render, staticRenderFns } from "./ConceptsTable.vue?vue&type=template&id=6272f5de"
import script from "./ConceptsTable.vue?vue&type=script&lang=js"
export * from "./ConceptsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports